import React from 'react';
import { TouchableOpacity, View, Text, ViewStyle } from 'react-native';
import IconChecked from '@/assets/icon/icon_check_red.png';

import { styles } from './style';
import Flex from '../atom/Flex';
import Image from '@kds/image';
import { KTouchableOpacity } from '../RtlLayout/Touchable';

export interface IRadioProps {
    disabled?: boolean;
    checked?: boolean;
    onChecked?: (val: boolean) => void;
    style?: ViewStyle;
    label?: React.ReactNode;
}
const Radio = (props: IRadioProps) => {
    const selected = props?.checked ?? false;
    const handlePress = () => {
        props.onChecked?.(!selected);
    };
    let imgNode = null;
    if (props.disabled) {
        imgNode = <View style={[styles.radio, styles.radioDisable]} />;
    } else {
        if (selected) {
            imgNode = <Image resizeMode="stretch" style={styles.radioCheckedIcon} source={IconChecked} />;
        } else {
            imgNode = <View style={[styles.radio]} />;
        }
    }
    return (
        <KTouchableOpacity style={[styles.box, props.style]} activeOpacity={0.6} onPress={handlePress}>
            <Flex flex={'flexRowCenter'}>
                {imgNode}
                {typeof props.label === 'string' ? <Text style={styles.labelText}>{props.label}</Text> : props.label}
            </Flex>
        </KTouchableOpacity>
    );
};

export default Radio;
